import React, { createContext, useState, useContext } from 'react';
import LoginPromptModal from '../components/modals/LoginPromptModal';

// Create the context
const LoginPromptContext = createContext(null);

const LoginPromptProvider = ({ children }) => {
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);

  // Function to open the modal
  const openLoginPrompt = () => {
    setShowLoginPrompt(true);
  };

  // Function to close the modal
  const closeLoginPrompt = () => {
    setShowLoginPrompt(false);
  };

  const contextValue = {
    openLoginPrompt,
    closeLoginPrompt,
  };

  return (
    <LoginPromptContext.Provider value={contextValue}>
      {children}
      {/* The modal is rendered here, controlled by the provider's state */}
      <LoginPromptModal
        isOpen={showLoginPrompt}
        onClose={closeLoginPrompt}
      />
    </LoginPromptContext.Provider>
  );
};

export default LoginPromptProvider;

// Custom hook to easily consume the context
export const useLoginPrompt = () => {
  const context = useContext(LoginPromptContext);
  if (!context) {
    throw new Error('useLoginPrompt must be used within a LoginPromptProvider');
  }
  return context;
};